import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import makeRequest from 'utils/makeRequest';
import { playNextVideo } from 'components/LitePlayer/util';
import Video from 'components/Video/V4VideoLoaderListing';
import InViewObserver from 'components/InViewObserver';
import { addNextVideoMsid } from 'routes/home/redux';
import Card from 'components_v2/common/CardV2';
import Listingheader from 'routes/home/components/common/ListingheaderV2';
import HeaderTab from 'routes/home/components/desktop/HeaderTabV2';
import LoaderSpinner from 'components_v2/common/LoaderSpinner';
import s from './VideoLayout.scss';

let videoWidgetPositionCounter = 0;

class VideoLayout extends React.Component {
  constructor() {
    super();
    this.videoListRef = React.createRef();

    // Generate unique IDs for each widget instance
    videoWidgetPositionCounter += 1;
    this.widgetPosition = videoWidgetPositionCounter;
    this.globalRefId = `lg_videowidget_${this.widgetPosition}`;
    this.playerContainerId = `lg_player_id_${this.widgetPosition}`;

    this.state = {
      slikeNextVideoAutoPlayed: false,
      navigation: {},
      shareUrl: '',
      isLoading: false,
      fetchedData: undefined,
    };
    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  // componentDidMount() {
  //   const { sectionData: { subSections = {} } } = this.props;
  //   if (subSections && subSections.dataUrl) {
  //     this.fetchNavigation(subSections.dataUrl);
  //   }
  // }

  loadNavigationData() {
    const { sectionData = {} } = this.props;
    if (sectionData.subSections && sectionData.subSections.dataUrl) {
      this.fetchNavigation(sectionData.subSections.dataUrl);
    }
  }

  fetchNavigation(dataUrl) {
    if (!dataUrl) {
      return;
    }

    makeRequest
      .get(dataUrl, { isMobile: this.props.isMobile }, 'skipfeedengine')
      .then(data => {
        if (
          data &&
          data.data &&
          data.data.items &&
          data.data.items.length > 0
        ) {
          this.setState({
            navigation: data.data.items,
          });
        }
      });
  }

  handleVideoClick(event, clickedVideoItem, index) {
    event.preventDefault();
    this.markPlaying(clickedVideoItem, false);
    // this.setState({
    //   slikeNextVideoAutoPlayed: false,
    // });
    if (this.props.gaFunction && typeof this.props.gaFunction === 'function') {
      this.props.gaFunction(clickedVideoItem, index);
    }
  }

  getNextVideosMsidArray = () => {
    const { sectionData = {} } = this.props;
    const videosData =
      this.state.fetchedData || sectionData.items || sectionData.data;
    return videosData.map(item => item.id);
  };

  onTabsChange = params => {
    if (!params) return;
    const { clickedItem } = params;
    const { dataUrl } = clickedItem;
    if (!dataUrl) {
      return;
    }
    this.setState({
      isLoading: true,
    });
    makeRequest
      .get(dataUrl, { isMobile: this.props.isMobile }, 'skipfeedengine')
      .then(data => {
        if (
          data &&
          data.data &&
          data.data.items &&
          data.data.items.length > 0
        ) {
          this.setState(
            {
              fetchedData: data.data.items,
            },
            this.setState({
              isLoading: false,
            }),
          );
        } else {
          this.setState({
            isLoading: false,
          });
        }
      })
      .catch(() => {
        this.setState({
          isLoading: false,
        });
      });
    // this.props.loadAjaxSectionData({ ...params, sectionId });
    this.setState({
      activeVideo: {},
    });
  };

  markPlaying = (data, slikeNextVideoAutoPlayed = true) => {
    const playingVideoMsid = typeof data === 'object' ? data && data.id : data;
    const shareUrl = typeof data === 'object' ? data && data.wu : '';
    const { sectionData = {} } = this.props;
    const videosData =
      this.state.fetchedData || sectionData.items || sectionData.data;
    const activeVideoArray = videosData.filter(
      video => video.id === playingVideoMsid,
    );
    const activeVideo = activeVideoArray[0];
    if (!(typeof activeVideo === 'object' && activeVideo.id)) {
      return;
    }

    // Store previous state to check if we need to play next video
    const prevActiveVideo = this.state.activeVideo;

    this.setState(
      {
        activeVideo,
        slikeNextVideoAutoPlayed,
        shareUrl,
      },
      () => {
        // Only call playNextVideo if we had a previous video playing and it's different
        if (
          prevActiveVideo &&
          prevActiveVideo?.playerId &&
          activeVideo?.playerId &&
          prevActiveVideo.playerId !== activeVideo.playerId
        ) {
          // Use the global ref ID from constructor
          playNextVideo(this.globalRefId, activeVideo?.playerId);
        }
      },
    );
  };

  setNextVideo = data => {
    const nextVideomsidArray = this.getNextVideosMsidArray();
    const oldMsid = data && data.id;
    const nextVideoIndex = nextVideomsidArray.indexOf(oldMsid) + 1;
    const newMsid = nextVideomsidArray[nextVideoIndex] || nextVideomsidArray[0];

    // Only proceed if we have a valid newMsid and it's different from current
    if (newMsid && newMsid !== oldMsid) {
      const playerData = this.getSlikeIdAndPlayerIdFromMsid(newMsid);
      const newSlikeId = playerData.slikeId;
      const newPlayerId = playerData.playerId;
      this.props.addNextVideoMsid(newMsid, newSlikeId, newPlayerId);
      this.markPlaying(newMsid);
    }
  };

  // videoEventListener = (messageName, data) => {
  //   const videoEvent = data ? data[1] : '';
  //   switch (videoEvent) {
  //     case 'VIDEOREADY':
  //       if (data && data instanceof Array && data[0]) {
  //         this.markPlaying(data[0]);
  //         this.setNextVideo(data[0]);
  //       }
  //       break;
  //     default:
  //     // console.log('messageName');
  //   }
  // };
  getPlayerType = playerType => {
    if (!playerType) {
      return '';
    }
    let playerTypeVal = '';
    switch (playerType) {
      case 'slike':
        playerTypeVal = '24';
        break;
      case 'youtube':
        playerTypeVal = '10';
        break;
      default:
        playerTypeVal = playerType;
    }

    return playerTypeVal;
  };

  getSlikeIdAndPlayerIdFromMsid(msid) {
    const playerData = {};
    const { sectionData } = this.props;
    if (sectionData) {
      const videosData =
        this.state.fetchedData || sectionData.items || sectionData.data;
      if (Array.isArray(videosData)) {
        for (let i = 0; i < videosData.length; i += 1) {
          if (videosData[i].id === msid) {
            playerData.slikeId = videosData[i].playerId;
            playerData.playerId = this.getPlayerType(videosData[i].playerType);
            break;
          }
        }
      }
    }

    return playerData;
  }

  videoEventListener = messageName => {
    this.a = '';
    if (messageName) {
      switch (messageName) {
        case 'VIDEOVIEW':
          break;
        // case 'VIDEOCOMPLETE':
        //   this.setState(currentState => {
        //     this.setNextVideo(currentState?.activeVideo);
        //     return currentState;
        //   });
        //   break;
        case 'VIDEOENDED':
          this.setState(currentState => {
            this.setNextVideo(currentState?.activeVideo);
            return currentState;
          });
          break;
        default:
      }
    }
  };

  renderRhsVideoList(activeVideo, activeSubsection) {
    const { sectionData = {} } = this.props;
    const videosData =
      this.state.fetchedData || sectionData.items || sectionData.data;
    return (
      <div className="grid_wrapper">
        {videosData.map((videoItem, index) => (
          <Card
            data={videoItem}
            itemClass={`col_l_4 col_m_6 ${
              activeVideo.id === videoItem.id ? s.vdoactive : ''
            }`}
            // videoWidget
            isVideoWidget
            isVerticalTile
            onClick={event =>
              this.handleVideoClick(event, videoItem, index + 1)
            }
            newga={`click-${sectionData &&
              sectionData.name}-${index}${activeSubsection &&
              `-${activeSubsection}`}#${videoItem.wu}`}
            key={videoItem.id}
            imgWidth="200"
            cssObj={{
              imgCont: s.border_color,
            }}
          />
        ))}
      </div>
    );
  }

  render() {
    const { sectionData = {}, isEtimesVideo } = this.props;
    const { navigation, shareUrl } = this.state;
    const activeSubsection = '';
    // const activeSubsection =
    //   sectionData.subSections &&
    //   sectionData.subSections.find(subsec => subsec.active);

    const activeVideo = this.state.activeVideo || {};
    const videosData =
      this.state.fetchedData || sectionData.items || sectionData.data;
    if (!videosData) return null;
    const initialVideo =
      videosData && Array.isArray(videosData) && videosData[0];
    const scrollGAAttr = {
      ...(sectionData.onScrollGA &&
        sectionData.id && { 'data-scrollga': sectionData.id }),
    };

    // let playListData = [];

    // if (
    //   sectionData &&
    //   Array.isArray(sectionData.items) &&
    //   sectionData.items.length > 0
    // ) {
    //   playListData = sectionData.items;
    // }

    return (
      <InViewObserver
        inViewCallback={() => {
          this.loadNavigationData();
        }}
        viewMargin="300px 0px 300px 0px"
      >
        <div className={s.videos_section} {...scrollGAAttr}>
          <Listingheader
            headingname={sectionData.name}
            headingLink={sectionData.link || sectionData.path}
            isWhiteTheme
            newga={`click-${sectionData.name}#${sectionData.link ||
              sectionData.path}`}
            target={sectionData.target}
          >
            <HeaderTab
              subSections={navigation}
              isWhiteTheme
              onChangeCallback={this.onTabsChange}
              newga={`${sectionData.name}Section_Actions_TabChange#Click_`}
            />
          </Listingheader>
          <div className="grid_wrapper">
            {activeVideo.id ? (
              <Video
                msid={activeVideo.id}
                videoClassName={`${'col_l_6 col_m_8'}`}
                videoClassInner={s.player_container_wrap}
                autoplay
                slikeNextVideoAutoPlayed={this.state.slikeNextVideoAutoPlayed}
                store={this.context.store}
                allowDim={false}
                slikeId={activeVideo.playerId}
                playerType={activeVideo.playerType}
                isUserPrime={this.props.isUserPrime}
                source={
                  isEtimesVideo ? 'ETimesVideoWidget' : 'USNHP_MainVideoWidget'
                }
                // videoPlayListData={playListData}
                outsideEventListener={(...args) => {
                  this.videoEventListener(...args);
                }}
                shareUrl={shareUrl}
                isVideoSkipAds={this.props.isVideoSkipAds}
                onClick={() => {
                  if (
                    this.props.gaFunction &&
                    typeof this.props.gaFunction === 'function'
                  ) {
                    this.props.gaFunction(initialVideo, 0);
                  }
                }}
                gestureControls
                tmplSource="listing"
                metakeywords={activeVideo?.metakeywords}
                globalRefId={this.globalRefId}
                playerContainerId={this.playerContainerId}
                newGamAdSection="widget_listing"
              />
            ) : (
              <div className="col_l_6 col_m_8">
                <Card
                  data={videosData[0]}
                  // itemClass="col_l_8"
                  videoWidget
                  isVideoWidget
                  isLeadVideo
                  cssObj={{
                    imgCont: s.border_color,
                  }}
                  onClick={event => {
                    event.preventDefault();
                    this.handleVideoClick(event, initialVideo, 0);
                  }}
                  newga={`${sectionData &&
                    sectionData.name}Section_Actions#$typeClick/lead/${
                    initialVideo.wu
                  }`}
                  imgWidth="600"
                />
              </div>
            )}
            <div
              className={`${s.video_list} col_l_6 col_m_4 ${
                this.props.className
              }`}
              ref={this.videoListRef}
            >
              {this.props.customScrollbarComp &&
              typeof this.props.customScrollbarComp === 'function' ? (
                <this.props.customScrollbarComp universal>
                  {this.renderRhsVideoList(activeVideo, activeSubsection)}
                </this.props.customScrollbarComp>
              ) : (
                this.renderRhsVideoList(activeVideo, activeSubsection)
              )}
            </div>
          </div>
          {this.state.isLoading && <LoaderSpinner />}
        </div>
      </InViewObserver>
    );
  }
}

const mapStateToProps = state => ({
  showVideoSectionLoader:
    (state.homepage && state.homepage.showVideoSectionLoader) ||
    (state.homepage_us && state.homepage_us.showVideoSectionLoader),
  isUserPrime: state.isPrime,
  isMobile: state.isMobile,
});

const mapDispatchToProps = dispatch => ({
  addNextVideoMsid: (msidForNextVideo, slikeId, playerId) => {
    dispatch(addNextVideoMsid(msidForNextVideo, slikeId, playerId));
  },
});

VideoLayout.propTypes = {
  sectionData: PropTypes.shape({
    data: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        hl: PropTypes.string,
        image: PropTypes.shape({}),
        du: PropTypes.string,
        imageid: PropTypes.string,
        wu: PropTypes.string,
      }),
    ),
  }).isRequired,
  loadAjaxSectionData: PropTypes.func,
  addNextVideoMsid: PropTypes.func.isRequired,
  showVideoSectionLoader: PropTypes.bool,
  className: PropTypes.string,
  isUserPrime: PropTypes.bool,
  isVideoSkipAds: PropTypes.bool,
  isMobile: PropTypes.bool,
  gaFunction: PropTypes.func,
};

VideoLayout.defaultProps = {
  showVideoSectionLoader: false,
  className: '',
  loadAjaxSectionData: undefined,
  isUserPrime: false,
  isVideoSkipAds: false,
  isMobile: false,
  gaFunction: undefined,
};

VideoLayout.contextTypes = {
  store: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoLayout);
